// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__11h6R"};